export type Environment = 'production' | 'development' | 'local' | 'staging';

export interface AppConfig {
  apiUrl: string;
  memberBase: string;
  userServiceUrl: string;
  environment: Environment;
}

export const appConfig: AppConfig = {
  apiUrl: process.env.REACT_APP_API_URL!!,
  memberBase: process.env.REACT_APP_MEMBER_BASE!!,
  userServiceUrl: process.env.REACT_APP_USER_SERVICE_URL!!,
  environment: (process.env.REACT_APP_ENV || 'local') as Environment,
};
